/** Browser entry: providers (router, session, branding, i18n, metadata, toasts) around the App. */
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import '../styles/design-system.css';
import './styles/app.css';
import { RouterProvider } from './lib/router.tsx';
import { SessionProvider, useSession } from './lib/session.tsx';
import { I18nProvider } from './lib/i18n.tsx';
import { MetaProvider } from './lib/meta.tsx';
import { BrandingProvider } from './lib/branding.tsx';
import { AiProvider } from './lib/ai.tsx';
import { ToastProvider } from './components/ui.tsx';
import { App } from './App.tsx';

function Localised({ children }: { children: React.ReactNode }) {
  const { locale } = useSession();
  return <I18nProvider locale={locale}>{children}</I18nProvider>;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider>
      <SessionProvider>
        <BrandingProvider>
          <Localised>
            <ToastProvider>
              <MetaProvider>
                <AiProvider>
                  <App />
                </AiProvider>
              </MetaProvider>
            </ToastProvider>
          </Localised>
        </BrandingProvider>
      </SessionProvider>
    </RouterProvider>
  </StrictMode>,
);
